import GuestField from 'components/common/MarchPromo/components/GuestField/GuestField'
import useGuestsForm from 'components/common/MarchPromo/utils/useGuestsForm'
import Box from 'components/shared/Box'
import Loader from 'components/shared/Loader'
import { GuestsFormProps } from './GuestsForm.types'

const GuestsForm = ({ voucherProductId, voucherPrice }: GuestsFormProps) => {
    const { marchVouchersData, setFieldInputValue, areVouchersDataReady } =
        useGuestsForm({
            voucherProductId,
            voucherPrice,
        })

    return (
        <Box gap={[16, 24]} isFullWidth>
            {!areVouchersDataReady ? (
                <Loader />
            ) : (
                marchVouchersData.map((voucher, index) => (
                    <GuestField
                        data={voucher}
                        index={index + 1}
                        onChange={setFieldInputValue}
                        key={voucher.boxId + index}
                    />
                ))
            )}
        </Box>
    )
}

export default GuestsForm
